module.exports = __webpack_public_path__ + "img/eyebrow_male_straight_thin_mask.f78bb51c.png";